import { render, staticRenderFns } from "./AgenteaduanaModals.vue?vue&type=template&id=2f13d60e"
import script from "./AgenteaduanaModals.vue?vue&type=script&lang=js"
export * from "./AgenteaduanaModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports